import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Riders from './Riders';
import Drivers from './Drivers';
import FleetAdmins from './FleetAdmins';
import CreateAdmin from './CreateAdmin';
import { useTranslation } from "react-i18next";
import { useParams ,useNavigate} from "react-router-dom";
import CreateSubAdmin from './CreateSubAdmin';

import { useSelector } from "react-redux";
import CircularLoading from "../components/CircularLoading";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Users() {
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const auth = useSelector(state => state.auth);
  const [role, setRole] = React.useState(null);

  React.useEffect(() => {
    if(auth.profile && auth.profile.usertype){
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  const handleChange = (event, newValue) => {
    navigate(`/users/${newValue}`);
};

React.useEffect(()=>{
  if (role !== null) {
    const tabIndex = Number(id);
    if (!isNaN(tabIndex) && tabIndex >= 0 && tabIndex <= 4) {
      if (role === 'fleetadmin' && tabIndex > 1) {
        navigate("/users/0");
      } else if (role === 'subadmin' && tabIndex > 2) {
        navigate("/users/0");
      } else {
        setValue(tabIndex);
      }
    } else {
      navigate("/404");
    }
  }
},[id, navigate, role]);

  if (role === null) {
    return <CircularLoading />;
  }
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', maxWidth: { xs: 'calc(100vw - 30px)', sm: '100%' } }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          <Tab style={{marginRight:"20px"}} label={t('riders')} {...a11yProps(0)} />
          <Tab style={{marginRight:"20px"}} label={t('drivers')} {...a11yProps(1)} />
          {role === 'fleetadmin'?
            null : <Tab style={{marginRight:"20px"}} label={t('fleetadmins')} {...a11yProps(2)} />
          }
          {role === 'fleetadmin' || role === 'subadmin'?
            null : <Tab label={t('alladmin')} {...a11yProps(3)} />
          }
          {role === 'fleetadmin' || role === 'subadmin'?
            null : <Tab label={t('subadmins')} {...a11yProps(4)} />
          }
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Riders/>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Drivers/>
      </TabPanel>
      {role !== 'fleetadmin' && (
        <TabPanel value={value} index={2}>
          <FleetAdmins/>
        </TabPanel>
      )}
      {role !== 'fleetadmin' && role !== 'subadmin' && (
        <>
          <TabPanel value={value} index={3}>
            <CreateAdmin/>
          </TabPanel>
          <TabPanel value={value} index={4}>
            <CreateSubAdmin/>
          </TabPanel>
        </>
      )}
    </Box>
  );
}